export default {
    GET_LOCALIZATIONS_REQUEST: state => {
        state.localizationsLoading = true
    },
    GET_LOCALIZATIONS_SUCCESS: (state, data) => {
        state.localizations = data.results
        state.localizationsLoading = false
    },
    GET_LOCALIZATIONS_FAILURE: state => {
        state.localizationsLoading = false
    },
    SET_LOCALIZATION_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_LOCALIZATION_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}